/* unplugin-vue-components disabled */import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { useUserStore } from '@/store/modules/user';
import { isExternal } from '@/utils/validate';
import { translateTitle } from '@/utils/i18n';
import { useRoutesStore } from '@/store/modules/routes';
import { defaultOpeneds, openFirstMenu, uniqueOpened } from '@/config';
import { useSettingsStore } from '@/store/modules/settings'; // import { screenIndex } from '@/api/screen'

import variables from '@vab/styles/variables/variables.module.scss';
import { get_notify, get_toker_data_count } from '@/api/message';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props, {
    expose
  }) {
    expose();
    const route = useRoute();
    const router = useRouter();
    const settingsStore = useSettingsStore();
    const {
      theme,
      collapse
    } = storeToRefs(settingsStore);
    const {
      foldSideBar,
      openSideBar
    } = settingsStore;
    const routesStore = useRoutesStore();
    const {
      is_toker_count
    } = useUserStore();
    const {
      getTab: tab,
      getTabMenu: tabMenu,
      getActiveMenu: activeMenu,
      getRoutes: routes,
      getPartialRoutes: partialRoutes
    } = storeToRefs(routesStore);
    const state = reactive({
      show: false,
      is_toker_count: is_toker_count,
      modules: {
        arr1: [{
          name: '电站信息',
          icon: require('@/assets/logo.png'),
          children: [{
            name: '电站信息总览',
            data: 'infoAll',
            datas: [],
            img: require('@/assets/login_images/background.jpg')
          }, {
            name: '发电数据统计',
            data: 'fadian',
            datas: [],
            img: require('@/assets/login_images/background.jpg')
          }]
        }, {
          name: '图表统计',
          children: [{
            name: '饼图',
            data: 'doublepie',
            img: require('@/assets/login_images/background.jpg')
          }, {
            name: '地区数据统计',
            data: 'areadata',
            datas: [],
            img: require('@/assets/login_images/background.jpg')
          }, {
            name: '最近几天发电',
            data: 'nearday',
            datas: [],
            img: require('@/assets/login_images/background.jpg')
          }, {
            name: '本月发电',
            data: 'nearmonth',
            datas: [],
            img: require('@/assets/login_images/background.jpg')
          }, {
            name: '累计发电',
            data: 'nearmonth',
            datas: [],
            img: require('@/assets/login_images/background.jpg')
          }, {
            name: '近几年发电',
            data: 'nearyear',
            datas: [],
            img: require('@/assets/login_images/background.jpg')
          }, {
            name: '电站分布',
            data: 'areadata',
            datas: [],
            img: require('@/assets/login_images/background.jpg')
          }, {
            name: '发电排名',
            data: 'areadata',
            datas: [],
            img: require('@/assets/login_images/background.jpg')
          }, {
            name: '发电个数排名',
            data: 'areadata',
            datas: [],
            img: require('@/assets/login_images/background.jpg')
          }, {
            name: '装机容量',
            data: 'areadata',
            datas: [],
            img: require('@/assets/login_images/background.jpg')
          }]
        }]
      },
      newDataArr: []
    });

    const handleTabClick = () => {
      nextTick(() => {
        if (isExternal(tabMenu.value.path)) {
          window.open(tabMenu.value.path);
          setTimeout(() => {
            router.push('/');
          }, 1000);
        } else if (openFirstMenu) router.push(tabMenu.value.redirect || tabMenu.value);
      });
    };

    watchEffect(() => {
      const foldUnfold = document.querySelector('.fold-unfold');

      if (theme.value.layout === 'column' && route.meta.noColumn) {
        foldSideBar();
        if (foldUnfold) foldUnfold.style = 'display:none';
      } else {
        openSideBar();
        if (foldUnfold) foldUnfold.style = '';
      }
    });
    const menuShow = ref(true);
    const show = ref(false);
    const count = ref(0);
    const counts = ref(0);
    const countg = ref(0);
    const countgz = ref(0);
    watch(tab, () => {
      menuShow.value = false;
      nextTick(() => {
        menuShow.value = true;

        if (tab.value.data == 'Screen') {
          show.value = true;
        } else {
          show.value = false;
        }
      });
    }, {
      deep: true
    });

    const fetchData = async () => {
      await get_notify({
        type: 10
      }).then(res => {
        count.value = res.data.industry;
        countgz.value = res.data.shareholding;
      });
      get_notify({
        type: 2024
      }).then(res => {
        counts.value = res.data;
      });

      if (state.is_toker_count == true) {
        get_toker_data_count().then(res => {
          countg.value = res.data.count;
        });
      } //    await screenIndex().then((res) => {
      //      console.log(res)
      //      res.area_data.forEach(function(item){
      //        if(item.province_name){
      //          item.name=item.province_name
      //        }else if(item.city_name){
      //          item.name=item.city_name
      //        }else if(item.area_name){
      //          item.name=item.area_name
      //        }
      //      })
      //       state.modules.arr1[0].children[0].datas = res;
      // state.modules.arr1[0].children[1].datas = res;
      //       state.modules.arr1[1].children[1].datas = res.area_data;
      //       state.modules.arr1[1].children[2].datas = res.near_day;
      //         state.modules.arr1[1].children[3].datas = res.near_month;
      //           state.modules.arr1[1].children[5].datas = res.near_year;
      //    })
      // state.list = list
      // state.newDataArr[0].children[0].datas=

    };

    onMounted(() => {
      // initData();
      fetchData();
    });
    const __returned__ = {
      route,
      router,
      settingsStore,
      theme,
      collapse,
      foldSideBar,
      openSideBar,
      routesStore,
      is_toker_count,
      tab,
      tabMenu,
      activeMenu,
      routes,
      partialRoutes,
      state,
      handleTabClick,
      menuShow,
      show,
      count,
      counts,
      countg,
      countgz,
      fetchData,
      translateTitle,
      defaultOpeneds,
      uniqueOpened,
      variables
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }

});